import type { ReactNode } from "react";

import { Card, CardContent } from "@/components/ui/card";

interface StatsCardProps {
  title: string;

  value: number;

  displayValue?: string;

  description?: string;

  icon?: ReactNode;
}

export const StatsCard = ({
  title,
  value,
  displayValue,
  description,
  icon,
}: StatsCardProps) => (
  <Card className="border-neutral-800 bg-neutral-900/50 backdrop-blur-sm">
    <CardContent className="p-5">
      <div className="flex items-center justify-between">
        <div className="text-sm uppercase tracking-wide text-neutral-400">
          {title}
        </div>
        {icon ? <div className="text-purple-400">{icon}</div> : null}
      </div>
      <div className="mt-3 text-3xl font-semibold text-white">
        {displayValue ?? value.toLocaleString("es-AR")}
      </div>
      {description ? (
        <div className="mt-1 text-sm text-neutral-400">{description}</div>
      ) : null}
    </CardContent>
  </Card>
);
